import { addDays, endOfDay, format, startOfDay } from 'date-fns/fp';

export const formatShortDateTime = format('dd/MM/yyyy HH:mm:ss');

export const today = () => new Date();
export const endOfToday = () => endOfDay(today());
export const startOfToday = () => startOfDay(today());
export const startOfYesterday = () => startOfDay(addDays(-1, startOfToday()));
export const startOfLast7 = () => startOfDay(addDays(-7, startOfToday()));
